require('jquery-ui-custom');
const _throttle = require('lodash/throttle');
const _debounce = require('lodash/debounce');
const dateUtils = require('../../scripts/date-utils');

const ignoreValidationClass = "ws-form__element--ignore-validation";

$.datepicker.setDefaults({
    changeMonth: true,
    changeYear: true,
    dateFormat: "mm/dd/yy",
    altFormat: "yy-mm-dd",
    yearRange: "1900:+40",
    prevText: "",
    nextText: "",
    // Fix buggy IE focus functionality 
    fixFocusIE: false,

    // Blur needed to correctly handle placeholder text
    onSelect: function () {
        this.fixFocusIE = true;
        $(this).blur().change().focus();
        $(this).datepicker("hide");
    },
    beforeShow: function () {
        // Add active class to the calendar button, this keeps the button highlighted while the datepicker is active
        const $button = $(this).siblings(".ws-material-group__tool-input-calendar");
        $button.addClass("ws-material-group__tool-input-calendar--active");

        // Prevent validation from firing while navigating the date picker
        $(this).addClass(ignoreValidationClass);
        const result = window.document.documentMode ? !this.fixFocusIE : true;
        this.fixFocusIE = false;
        return result;
    },
    onClose: function () {
        // Remove active class from the calendar button, this returns the button to its normal state when the datepicker is closed
        const $button = $(this).siblings(".ws-material-group__tool-input-calendar");
        $button.removeClass("ws-material-group__tool-input-calendar--active");

        $(this).removeClass(ignoreValidationClass);
        $(this).focus().valid(); // Re-focus on the input box and trigger validation
    }
});

function parseDateBoundary(attributeValue) {
    if (!attributeValue) {
        return null;
    }

    const parsedDate = new Date(dateUtils.resolveDateToken(attributeValue));
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
}

// Mirrors the daterange validation bounds so the calendar cannot offer dates the validator will reject
function getDateRangeOptions($datepicker) {
    const options = {};
    const minDate = parseDateBoundary($datepicker.attr("data-val-daterange-min"));
    const maxDate = parseDateBoundary($datepicker.attr("data-val-daterange-max"));

    if (minDate) {
        options.minDate = minDate;
    }

    if (maxDate) {
        options.maxDate = maxDate;
    }

    return options;
}

$(".ws-form__element-datepicker").each(function () {
    const $datepicker = $(this);
    const uniqueId = $datepicker.attr("id");

    if (uniqueId) {
        $datepicker.datepicker(getDateRangeOptions($datepicker));
        $datepicker.data("initial-status", false);
    }
});

$("button[id$='calendar']").on("click", function (e) {
    e.preventDefault();

    const $datepicker = $(`#${$(this).data("datepicker-id")}`);

    if ($datepicker.length) {
        const isVisible = $(".ui-datepicker:visible").length > 0;
        const initialStatus = $datepicker.data("initial-status") || false;

        if (isVisible && initialStatus) {
            $datepicker.datepicker("hide");
            $(this).attr("aria-expanded", "false");
        } else {
            $datepicker.data("initial-status", true);
            $datepicker.datepicker("show");
            $(this).attr("aria-expanded", "true");
        }
    }
});

// Handle window resize events for all datepickers
$(window).on("resize", _throttle(function () {
    const field = $(document.activeElement);
    if (field.is(".ws-form__element-datepicker")) {
        field.datepicker("hide");
    }
}, 200));

$(window).on("resize", _debounce(function () {
    const field = $(document.activeElement);
    if (field.is(".ws-form__element-datepicker")) {
        field.datepicker("show");
    }
}, 200));